import utils from 'utils/utils';

export default function (stream, isEnabled, youboraAccount) {
    function getYouboraConfig(config) {
        config = (typeof config === 'object') ? config : {};

        return {
            'https://smartplugin.youbora.com/v5/javascript/jwplayer/5.4.1/sp.min.js': utils.extend({
                // Account code and enable YOUBORA Analytics
                accountCode: 'schibsted',
                enableAnalytics: true
            }, config)
        };
    }

    // additional config options required for playback
    return function (config) {
        // allow only when account config is available
        if (isEnabled && youboraAccount) {
            utils.extend(
                config.plugins,
                getYouboraConfig(youboraAccount)
            );

            /* jshint ignore:start */
            if (config.playlist && config.playlist[0]) {
                config.playlist[0].youbora = {
                    media: {
                        title: stream.get('title'),
                        duration: stream.getDuration(),
                        isLive: stream.isLive(),
                        cdn: 'AKAMAI',
                        resource: stream.getUrl('hls')
                    },

                    properties: {
                        content_id: stream.getId(),
                        content_metadata: {
                            owner: stream.getVendor()
                        }
                    }
                };
            }
            /* jshint ignore:end */
        }

        return config;
    };
}
